import Config from '@/config';
import {
  FilterResponse,
  ListParams,
  ListResult,
  FavoriteResult,
  HistoryParams,
  HistoryResult,
  DetailResult,
} from '@/types/api/lots';
import http, { HttpPromise } from './http';

const filterParams = (role: string): HttpPromise<FilterResponse> => http.post<FilterResponse>(`${Config.apiHost}/${role}/lots/filter/`);
const list = (role: string, params?: ListParams): HttpPromise<ListResult> => http.get<ListResult>(`${Config.apiHost}/${role}/lots/list/`, { params });
const favoriteList = (role: string, params?: ListParams): HttpPromise<ListResult> => http.get<ListResult>(`${Config.apiHost}/${role}/lots/favorite/lotList/`, { params });
const supplierParticipateList = (role: string, params?: ListParams): HttpPromise<ListResult> => http.get<ListResult>(`${Config.apiHost}/${role}/lots/participate/lotList/`, { params });
const favorite = (role: string, lotId: number): HttpPromise<FavoriteResult> => http.post<FavoriteResult>(`${Config.apiHost}/${role}/lots/favorite/`, { id: lotId });
const history = (role: string, params?: HistoryParams): HttpPromise<HistoryResult> => http.get<HistoryResult>(`${Config.apiHost}/${role}/lots/history/`, { params });
const detail = (role: string, params: { id: number }): HttpPromise<DetailResult> => http.get<DetailResult>(`${Config.apiHost}/${role}/lots/detail/`, { params });
const clarificationDetail = (role, lotId) => http.get<DetailResult>(`${Config.apiHost}/${role}/clarification/detail/`, { params: { id: lotId } });
const clarificationAddMessage = (role, data) => http.post<DetailResult>(`${Config.apiHost}/${role}/clarification/addMessage/`, data);
const downloadLotNomenclature = (role, lotId) => http.get<HttpPromise>(`${Config.apiHost}/${role}/lots/nomenclature/`, { params: { id: lotId }, responseType: 'blob' });
const customerUpdatePhone = (lotId: number, phone: string): HttpPromise<DetailResult> => http.post<DetailResult>(`${Config.apiHost}/customer/lots/updateContactPhone/`, { id: lotId, contactPhone: phone });

export default {
  pub: {
    filterParams: filterParams.bind(this, 'pub'),
    list: list.bind(this, 'pub'),
    detail: detail.bind(this, 'pub'),
  },
  supplier: {
    list: list.bind(this, 'supplier'),
    favorite: favorite.bind(this, 'supplier'),
    history: history.bind(this, 'supplier'),
    favoriteList: favoriteList.bind(this, 'supplier'),
    participateList: supplierParticipateList.bind(this, 'supplier'),
    detail: detail.bind(this, 'supplier'),
    supplyOffer: (data) => http.post<DetailResult>(`${Config.apiHost}/supplier/lots/supplyOffer/`, data),
    clarificationDetail: clarificationDetail.bind(this, 'supplier'),
    clarificationCreate: (data) => http.post<DetailResult>(`${Config.apiHost}/supplier/clarification/create/`, data),
    clarificationAddMessage: clarificationAddMessage.bind(this, 'supplier'),
    downloadLotNomenclature: downloadLotNomenclature.bind(this, 'supplier'),
  },
  contractor: {
    list: list.bind(this, 'contractor'),
    favorite: favorite.bind(this, 'contractor'),
    favoriteList: favoriteList.bind(this, 'contractor'),
    history: history.bind(this, 'contractor'),
    detail: detail.bind(this, 'contractor'),
    clarificationDetail: clarificationDetail.bind(this, 'contractor'),
    clarificationAddMessage: clarificationAddMessage.bind(this, 'contractor'),
    updateContactPhone: customerUpdatePhone.bind(this),
  },
  customer: {
    list: list.bind(this, 'customer'),
    favorite: favorite.bind(this, 'customer'),
    favoriteList: favoriteList.bind(this, 'customer'),
    history: history.bind(this, 'customer'),
    downloadLotArchive: async (params): Promise<HttpPromise> => {
      const response = await http.get(`${Config.apiHost}/customer/lots/supplyOffers/download/`, { params, responseType: 'blob' });
      return response;
    },
    detail: detail.bind(this, 'customer'),
    clarificationDetail: clarificationDetail.bind(this, 'customer'),
    clarificationAddMessage: clarificationAddMessage.bind(this, 'customer'),
  },
  administrator: {
    list: list.bind(this, 'administrator'),
    favorite: favorite.bind(this, 'customer'),
    favoriteList: favoriteList.bind(this, 'customer'),
    detail: detail.bind(this, 'customer'),
    clarificationDetail: clarificationDetail.bind(this, 'customer'),
    clarificationAddMessage: clarificationAddMessage.bind(this, 'customer'),
    downloadLotArchive: async (params): Promise<HttpPromise> => {
      const response = await http.get(`${Config.apiHost}/customer/lots/supplyOffers/download/`, { params, responseType: 'blob' });
      return response;
    },
    history: history.bind(this, 'administrator'),
  },
};
